import React from 'react'
import Toolbar from '@mui/material/Toolbar'
import MenuIcon from '@mui/icons-material/Menu'
import { TopBarElements } from './TopBarElements'
import { TopBarProps } from './TopBarTypes'
import IconButton from 'components/IconButton/IconButton'
import PersonIcon from '@mui/icons-material/Person'
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone'
import Menu from 'components/Menu/Menu'
import { useAuthNavigation } from 'hooks/useNavigation'

export default function TopBar({ open, setOpen, isMobile }: TopBarProps): JSX.Element {
  const { navigateToLogout } = useAuthNavigation()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const isProfileDropdownOpen = Boolean(anchorEl)

  const handleProfileClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseProfileDropdown = (): void => {
    setAnchorEl(null)
  }

  // On mobile, always show hamburger. On desktop, hide when sidebar is open.
  const showHamburger = isMobile || !open

  return (
    <TopBarElements.AppBar elevation={0} position="static">
      <Toolbar
        disableGutters={true}
        sx={{
          padding: isMobile ? '0 12px' : '0 24px',
          minHeight: '64px',
        }}
      >
        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            color: 'rgba(255, 255, 255, 0.9)',
            marginRight: isMobile ? 2 : 5,
            transition: 'all 0.3s ease',
            minWidth: '44px',
            minHeight: '44px',
            '&:hover': {
              color: '#a855f7',
              background: 'rgba(168, 85, 247, 0.1)',
              transform: 'scale(1.05)',
            },
            ...(!showHamburger && { display: 'none' }),
          }}
        >
          <MenuIcon />
        </IconButton>
        <TopBarElements.IconsWrapper>
          <IconButton
            sx={{
              color: 'rgba(255, 255, 255, 0.9)',
              transition: 'all 0.3s ease',
              '&:hover': {
                color: '#a855f7',
                background: 'rgba(168, 85, 247, 0.1)',
                transform: 'scale(1.05)',
              },
            }}
          >
            <NotificationsNoneIcon />
          </IconButton>
          <IconButton
            sx={{
              color: 'rgba(255, 255, 255, 0.9)',
              transition: 'all 0.3s ease',
              '&:hover': {
                color: '#a855f7',
                background: 'rgba(168, 85, 247, 0.1)',
                transform: 'scale(1.05)',
              },
            }}
            onClick={handleProfileClick}
          >
            <PersonIcon />
          </IconButton>
        </TopBarElements.IconsWrapper>
      </Toolbar>

      <Menu
        MenuProps={{
          anchorEl,
          open: isProfileDropdownOpen,
          onClose: handleCloseProfileDropdown,
        }}
        items={[
          { children: 'Logout', key: 'Logout', onClick: navigateToLogout },
        ]}
      />
    </TopBarElements.AppBar>
  )
}